import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import {removePendingSubmission} from "../../../store/coreSlice";

const RemovePending = (props) => {
	const handleVerify = () => {
		props.removePendingSubmission(props.latitude, props.longitude, props.keyName);
		props.polygon.setOptions({fillOpacity: 0});
		props.onClose();
	};

	return (<Dialog open={true}>
			<DialogTitle id="alert-dialog-title">Removing PokéStop Submission</DialogTitle>
			<DialogContent>
				Do you want to remove your submission for this cell? (ie, if it was rejected or you clicked the wrong place)
			</DialogContent>
			<DialogActions>
				<Button onClick={props.onClose}>
					Cancel
				</Button>
				<Button onClick={handleVerify} color="primary">
					Remove Submission
				</Button>
			</DialogActions>
		</Dialog>);
};

RemovePending.propTypes = {
	onClose: PropTypes.func.isRequired,
	latitude: PropTypes.number.isRequired,
	longitude: PropTypes.number.isRequired,
	keyName: PropTypes.string.isRequired,
	polygon: PropTypes.object.isRequired
};

const mapDispatchToProps = (dispatch) => {
	return {
		removePendingSubmission: (latitude, longitude, key) => dispatch(removePendingSubmission(latitude, longitude, key)),
	};
};

export default connect(null, mapDispatchToProps)(RemovePending);